const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/hooks/useDidUpdateEffect.ts';
import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

export const useDidUpdateEffect = (effect: EffectCallback, deps?: DependencyList) => {
    const didMountRef = useRef(false);

    useEffect(() => {
        // The first effect run only marks the component as mounted;
        // later dependency changes run the callback.
        if (didMountRef.current) {
            return effect();
        }

        didMountRef.current = true;
        return undefined;
    }, deps);
};
